import * as yup from 'yup';

export const schema12HourMode = yup
  .object()
  .shape({
    hours: yup.number().max(12, 'Max 12').min(0, 'Min 0').required('Required'),
    minutes: yup
      .number()
      .max(59, 'Max 59')
      .min(0, 'Min 0')
      .required('Required'),
  })
  .required();

export const schema24HourMode = yup
  .object()
  .shape({
    hours: yup.number().max(23, 'Max 23').min(0, 'Min 0').required('Required'),
    minutes: yup
      .number()
      .max(59, 'Max 59')
      .min(0, 'Min 0')
      .required('Required'),
  })
  .required();

export interface Schema {
  hours: number;
  minutes: number;
  timePeriod?: 'AM' | 'PM';
}
